import NoContentTextView from 'js/components/elements/NoContentTextView';
import { CONTACT_SUPPORT_LINK } from 'js/constants/config';
import { ROUTE_DATA_SOURCES } from 'js/constants/pathnames';
import { SUPPORT_KEY_SOURCE_LIST_VIEW } from 'js/constants/supportPageKeys';
import {
  ACLQueryModeTypes,
  AvailableFilterTypesByView,
  SearchFilterViews,
} from 'js/constants/visibilityFilters';
import { isFinite } from 'lodash';
import { BannerDescription } from 'new/elements/BannerDescription';
import React from 'react';
import { withRouter } from 'react-router-dom';
import DataSourcesTable from './DataSourcesTable';
import RoutePrefixContext from '../../../new/contexts/RoutePrefixContext';
import ResourceEditProvider from 'js/components/ResourceEditProvider';

const availableFilterTypes = AvailableFilterTypesByView[SearchFilterViews.SOURCES];

const description =
  'Nexla simplifies managing diverse data sources like databases, cloud storage, APIs, FTP servers, and webhooks. \nAutomated scans extract Nexsets for seamless data integration.';

class ViewDataSources extends React.Component {
  static contextType = RoutePrefixContext;

  componentDidMount() {
    // TODO: temp for NEX-2859. Need to fetch Data Maps for API sources Edit Screen.
    //Ideally should make API source edit smart enough to reconcile with datamaps response
    this.props.loadDataMaps(false, ACLQueryModeTypes.MODE_COLLABORATOR.key);
    this.props.setContextualSupport(SUPPORT_KEY_SOURCE_LIST_VIEW);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.sourceId && prevProps.sourceId !== this.props.sourceId) {
      this.props.loadDataSource(this.props.sourceId, this.props.aclQueryMode);
    }
  }

  componentWillUnmount() {
    this.props.unsetContextualSupport(SUPPORT_KEY_SOURCE_LIST_VIEW);
  }

  render() {
    const {
      allSources,
      sources,
      sourceId,
      getSourceMeta,
      onlyTableView,
      selectedCardID,
      isLoading,
      loadDataSources,
    } = this.props;
    const singleItemMode = isFinite(sourceId) ? true : false;

    const meta = getSourceMeta(selectedCardID);

    let noContentView = null;
    if (!isLoading && allSources && allSources.length === 0) {
      if (singleItemMode === true) {
        noContentView = (
          <NoContentTextView
            title={<div>We are sorry, we could not find this source.</div>}
            subtitle={
              <div>
                Please reload the page or file a{' '}
                <a style={{ color: '#507fe7' }} href={CONTACT_SUPPORT_LINK}>
                  support ticket
                </a>{' '}
                to request support.
              </div>
            }
          />
        );
      } else {
        noContentView = (
          <NoContentTextView
            title={
              <div>
                Add your first Data Source! Click on the Create New Flow button to get started.
              </div>
            }
            subtitle={
              <div>
                File a{' '}
                <a style={{ color: '#507fe7' }} href={CONTACT_SUPPORT_LINK}>
                  support ticket
                </a>{' '}
                to request support for a new source
              </div>
            }
          />
        );
      }
    }

    return (
      <ResourceEditProvider>
        <div>
          <BannerDescription title="Sources" description={description} />
          <DataSourcesTable
            view={SearchFilterViews.SOURCES}
            urlId={sourceId}
            isLoading={isLoading}
            cardsData={sources}
            data={sources}
            availableFilterTypes={availableFilterTypes}
            noContentView={noContentView}
            getSourceMeta={getSourceMeta}
            loadData={loadDataSources}
          />
        </div>
      </ResourceEditProvider>
    );
  }

  _handleCreateSourceClicked = () => {
    this.props.history.push(`${ROUTE_DATA_SOURCES}/new`);
  };
}

ViewDataSources.defaultProps = {
  onlyTableView: false,
};

export default withRouter(ViewDataSources);
